<template lang="pug">
#plan_select
  plan-interval-menu(:interval="interval", :interval_count="interval_count", :is_new_ui="is_new_ui")
  div.text-right.mb-2
    a(href="/users/plans/custom") 200万PV以上をご希望の方はこちら
  table.table.table-bordered
    thead
      tr
        th.blank(:colspan="2")
        th(v-for="plan in display_plans",:class="plan.name") {{planDisplayName(plan)}}
    tbody
      tr
        th(:colspan="2" :rowspan="2") 料金
        td(v-for="plan in display_plans")
          template(v-if="is_monthly")
            strong {{toCurrency(plan.amount/month_param)}}円
          template(v-else-if="plan.name=='free'")
            strong {{toCurrency(plan.amount/month_param)}}円
          template(v-else)
            strong {{formatPrice(plan.amount)}}円
            br/
            strong(style="font-size: 14px;") 月払いより{{savingPeriodText}}
            br/
            strong(style="font-size: 14px;") {{formatSavingAmount(plan.amount)}}円 お得
      tr(v-if="!no_button && !invoice_failed")
        td.text-center(v-for="(plan, index) in display_plans")
          template(v-if="isSamePlan(plan)")
            template(v-if="isSameId(plan)")
              button.btn.btn-default 現在のプラン
            template(v-else-if="plan.name == 'free'")
              button.btn.btn-default 現在のプラン
            template(v-else)
              button.btn.btn-default(@click="upgrade( plan )") 支払期間変更
          template(v-else-if="isLowerPlan(plan)")
            template(v-if="index!=0")
              template(v-if="plan.name == 'premium'")
                button.btn.btn-secondary(disabled style="opacity: 0.5") ダウングレード
                div.text-danger.small.mt-1 ※新規申込終了
              template(v-else)
                button.btn.btn-secondary(@click="downgrade( plan )") ダウングレード
            template(v-else)
              button.btn.btn-secondary(@click="cancelPlan") ダウングレード
          template(v-else-if="isUpperPlan(plan)")
            template(v-if="plan.name == 'premium'")
              button.btn.btn-primary(disabled style="opacity: 0.5") アップグレード
              div.text-danger.small.mt-1 ※新規申込終了
            template(v-else)
              button.btn.btn-primary(@click="upgrade( plan )") アップグレード
      tr
        th.empty(:colspan="plan_count")
      tr
        th(:colspan="2" :rowspan="1")
          | 利用可能ドメイン数
          help-tooltip(html-key='planDomain')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)") 3
          template(v-else-if="isMaster(plan)") 2
          template(v-else-if="isEnterprise(plan)") 3
          template(v-else) 1
      tr
        th(:colspan="2" :rowspan="1")
          | データ保存期間
          help-tooltip(html-key='planRetention')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)") 400日
          template(v-else-if="isEnterprise(plan)") 400日
          template(v-else-if="isMaster(plan)") 180日
          template(v-else-if="isBasic(plan)") 180日
          template(v-else) 30日
      tr
        th.empty(:colspan="plan_count+1")
    tbody
      tr
        th.heatmap(:rowspan="7", style='width: 10%;')
          | ヒートマップ
          help-tooltip(html-key='planHeatmap')
      tr
        th
          | PV数
          help-tooltip(html-key='planHeatmapPv')
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1,000
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.heatmap_imp_limit.toLocaleString()}}/月
      tr
        th 計測URL数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th
          div ヒートマップ3種
          div （スクロール・クリック・アテンション）
        td(v-for="plan in display_plans" style="vertical-align: middle;")
          template
            i.fa.fa-check-circle あり
      tr
        th
          | Webサイトデザイン保存数
          help-tooltip(html-key='planHeatmapDesign')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle 5
          template(v-else-if="!isMoreMaster(plan)") 1
          template(v-else)
            i.fa.fa-check-circle 5
      tr
        th
          | 並列表示
          help-tooltip(html-key='planHeatmapParallel')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | 外部共有
          help-tooltip(html-key='planHeatmapShare')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="!isMoreMaster(plan)") なし
          template(v-else)
            i.fa.fa-check-circle あり

      tr
        th.empty(:colspan="plan_count")
      tr
        th.popup(:rowspan="17", style='width: 10%;')
          div
            | ポップアップ
            help-tooltip(html-key='planPopup')
          div オーバーレイ
      tr
        th
          | PV数
          help-tooltip(html-key='planPopupPv')
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1,000
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.overlay_imp_limit.toLocaleString()}}/月
      tr
        th 離脱防止ポップアップ
        td(v-for="plan in display_plans")
          template
            i.fa.fa-check-circle あり
      tr
        th
          | 特定条件ポップアップ
          help-tooltip(html-key='planPopupSpecific')
        td(v-for="plan in display_plans")
          template
            i.fa.fa-check-circle あり
      tr
        th
          | シナリオポップアップ
          help-tooltip(html-key='planPopupScenario')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isEnterprise(plan)")
            i.fa.fa-check-circle あり
          template(v-else) なし
      tr
        th 電話ポップアップ
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isEnterprise(plan)")
            i.fa.fa-check-circle あり
          template(v-else) なし
      tr
        th オーバーレイ（画面右下）
        td(v-for="plan in display_plans")
          template
            i.fa.fa-check-circle あり
      tr
        th 登録クリエイティブ数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th
          | クリエイティブABテスト
          help-tooltip(html-key='planPopupAb')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | パラメータ引継ぎ
          help-tooltip(html-key='planPopupParams')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | カウントダウンタイマー
          help-tooltip(html-key='planPopupTimer')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | 表示日時予約
          help-tooltip(html-key='planPopupSchedule')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | 表示曜日・時間指定
          help-tooltip(html-key='planPopupWeek')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | 表示回数制限
          help-tooltip(html-key='planPopupOnce')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | ドメイン離脱指定
          help-tooltip(html-key='planPopupDomainLeave')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | AI離脱予測機能
          help-tooltip(html-key='planPopupAiLeave')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | 「Powered By SiteLead」表記停止
          help-tooltip(html-key='planPopupPowered')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし

      tr
        th.empty(:colspan="plan_count")
      tr
        th.conversion(:rowspan="5", style='width: 10%;')
          div
            | コンバージョン計測
            help-tooltip(html-key='planCv')
      tr
        th
          | ページビュー計測
          help-tooltip(html-key='planCvPageView')
        td(v-for="plan in display_plans")
          template
            i.fa.fa-check-circle あり
      tr
        th
          | ボタンクリック計測【開発中】
          help-tooltip(html-key='planCvClick')
        td(v-for="plan in display_plans")
          template
            i.fa.fa-check-circle あり
      tr
        th
          | LINE友達追加計測【開発中】
          help-tooltip(html-key='planCvLine')
        td(v-for="plan in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          | ASP連携【開発中】
          help-tooltip(html-key='planCvAsp')
        td(v-for="(plan, index) in display_plans")
          template(v-if="isHighVolumePlan(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし

      tr(v-if="!no_button && !invoice_failed")
        th.blank(:colspan="2")
        td.text-center(v-for="(plan, index) in display_plans")
          template(v-if="isSamePlan(plan)")
            template(v-if="isSameId(plan)")
              button.btn.btn-default 現在のプラン
            template(v-else-if="plan.name == 'free'")
              button.btn.btn-default 現在のプラン
            template(v-else)
              button.btn.btn-default(@click="upgrade( plan )") 支払期間変更
          template(v-else-if="isLowerPlan(plan)")
            template(v-if="index!=0")
              button.btn.btn-secondary(@click="downgrade( plan )") ダウングレード
            template(v-else)
              button.btn.btn-secondary(@click="cancelPlan") ダウングレード
          template(v-else-if="isUpperPlan(plan)")
            button.btn.btn-primary(@click="upgrade( plan )") アップグレード
</template>

<script>



import Vue from 'vue';

import StrMixin from '../mixins/str';

import PlanIntervalMenu from '../components/plan_interval_menu.vue';

export default {
  props: {
    plans: { type: String, default: [] },
    plan_interval_name: {type: String, default: "month"},
    current_plan_name: { type: String, default: "free" },
    current_plan_id: { type: String, default: null },
    has_stripe_customer_id: { type: Boolean, default: null },
    invoice_failed: { type: Boolean, default: false },
    is_upgrade: { type: Number, default: 0, require: false },
    hide_above_idx: { type: Number, default: 0, require: false },
    no_button: { type: Boolean, default: false },
    interval: { type: String, default: "month" },
    interval_count: { type: String, default: "1" },
    is_new_ui: { type: Boolean, default: false },
  },
  data(){
    return {
      plans_arr: [],
    }
  },
  components: {
    PlanIntervalMenu
  },
  methods: {
    upgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      if(this.has_stripe_customer_id == false){
        this.$bvModal.show('set-user-credit-card')
      } else {
        // 保持してるクーポンは一度リセット
        if (this.$store.state.user.coupon_code) this.$store.commit("user/setCouponCode", "")
        this.$bvModal.show('change-user-plan')
      }
    },
    downgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      // 保持してるクーポンは一度リセット
      if (this.$store.state.user.coupon_code) this.$store.commit("user/setCouponCode", "")
      this.$bvModal.show('change-user-plan')
      //this.resetCurrentPlanIdx(plan.name)
    },
    cancelPlan(){
      this.$bvModal.show('cancel-user-plan')
      //this.resetCurrentPlanIdx("free")
    },
    isUpperPlan(plan){
      return this.$store.getters["user/is_upper_plan"](plan)
    },
    isLowerPlan(plan){
      return this.$store.getters["user/is_lower_plan"](plan)
    },
    isSamePlan(plan){
      return this.$store.getters["user/is_same_plan"](plan)
    },
    isSameId(plan){
      return this.$store.getters["user/is_same_id"](plan)
    },
    planByIdx(idx){
      let plans = this.$store.getters["user/display_plans"]
      return plans[idx]
    },
    resetCurrentPlanIdx(new_plan_name){
      var _this = this
      this.plans_arr.forEach((plan, idx)=>{
        if(new_plan_name == plan.name){
          _this.current_plan_idx = idx
        }
      })
    },
    isOneDomain(plan){
      if(
        plan.name=="free" ||
        plan.name=="basic"
      ){
        return true
      } else {
        return false
      }
    },
    hasCountdown(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise"
      ){
        return true
      } else {
        return false
      }
    },
    isMoreMaster(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise"
      ){
        return true
      } else {
        return false
      }
    },
    isMaster(plan){
      if(
        plan.name=="master"
      ){
        return true
      } else {
        return false
      }
    },
    isFree(plan){
      if(
        plan.name=="free"
      ){
        return true
      } else {
        return false
      }
    },
    isBasic(plan){
      if(
        plan.name=="basic"
      ){
        return true
      } else {
        return false
      }
    },
    isEnterprise(plan){
      if(
        plan.name=="enterprise"
      ){
        return true
      } else {
        return false
      }
    },
    is1mPv(plan){
      return plan.name == "1m_pv"
    },
    is2mPv(plan){
      return plan.name == "2m_pv"
    },
    isHighVolumePlan(plan){
      return this.is1mPv(plan) || this.is2mPv(plan)
    },
    isEnterpriseOrHigher(plan){
      return this.isEnterprise(plan) || this.isHighVolumePlan(plan)
    },
    planDisplayName(plan){
      if(this.is1mPv(plan)){
        return "100万PV"
      } else if(this.is2mPv(plan)){
        return "200万PV"
      } else {
        return plan.display_name
      }
    },
    formatPrice(number){
      return (number/(this.month_param)).toLocaleString('ja-JP')
    },
    formatBeforePrice(number){
      return parseInt((number/(this.month_param))*(1/(1-this.discount))).toLocaleString('ja-JP')
    },
    formatAnnualBeforePrice(number){
      return parseInt(((number/(this.month_param))*(1/(1-this.discount))-number/(this.month_param))*12).toLocaleString('ja-JP')
    },
    formatSavingAmount(number){
      // 月額料金を計算
      const monthlyPrice = number / this.month_param
      // 割引前の月額料金（月払いの料金）
      const originalMonthlyPrice = monthlyPrice / (1 - this.discount)
      // 1ヶ月あたりの節約額
      const savingPerMonth = originalMonthlyPrice - monthlyPrice
      // 契約期間分の節約額
      const totalSaving = savingPerMonth * this.month_param

      return parseInt(totalSaving).toLocaleString('ja-JP')
    },

    dataPeriod(plan){
      if(
        plan.name=="custom" ||
        plan.name=="enterprise"
      ){
        return "365日"
      } else {
        return "180日"
      }
    },
  },
  mixins:[StrMixin],
  watch: {
    '$store.state.user.plan_name': function (val) {
      this.$store.dispatch("user/updateCurrentPlanIdx")
    },
  },
  computed: {
    plan_name(){
      return this.$store.state.user.plan_name
    },
    plan_count(){
      if(this.display_plans!=undefined){
        return this.display_plans.length+1
      } else {
        1
      }
    },
    display_plans(){
      let plans = this.$store.getters["user/display_plans"]
      plans = plans?.filter(plan => plan.name != "premium")

      let plan_ranks = []
      if(this.is_upgrade){
        plan_ranks = {
          free : 0,
          basic :1,
          master : 2,
          enterprise : 3,
          '1m_pv': 4,
          '2m_pv': 5
        }
        let current_plan_rank = plan_ranks[this.current_plan_name]
        if(plans!=undefined){
          return plans.filter(plan => plan_ranks[plan.name] >= current_plan_rank)
        }
      } else {
        return plans
      }
    },
    month_param(){
      if(this.$store.state.user.is_anual){
        return 12
      } else {
        return parseInt(this.$store.state.user.interval_count)
      }
    },
    discount(){
      if(this.$store.state.user.is_anual){
        return 0.25  // 年払い: 25% OFF
      } else {
        if(this.$store.state.user.interval_count == 36){
          return 0.5  // 3年払い: 50% OFF
        } else if(this.$store.state.user.interval_count == 6){
          return 0.3  // 6ヶ月払い: 30% OFF
        } else if(this.$store.state.user.interval_count == 3) {
          return 0.2  // 3ヶ月払い: 20% OFF
        } else {
          return 0
        }
      }
    },
    plan_span_name(){
      if(this.interval == "year"){
        return "1年間プラン"
      } else {
        return this.interval_count+"ヶ月払いプラン"
      }
    },
    is_monthly(){
      if(!this.$store.state.user.is_anual && this.$store.state.user.interval_count == 1){
        return true
      } else {
        return false
      }
    },
    savingPeriodText(){
      if(this.$store.state.user.is_anual){
        return "年間"
      } else if(this.$store.state.user.interval_count == 36){
        return "3年間"
      } else if(this.$store.state.user.interval_count == 6){
        return "6ヶ月"
      } else if(this.$store.state.user.interval_count == 3){
        return "3ヶ月"
      } else {
        return "年間"
      }
    }
  },
  async mounted(){
    await Vue.nextTick()
    //console.log("this.interval_count",this.interval_count)
    this.$store.commit("user/setPlanId", this.current_plan_id)
    this.$store.commit("user/setHideAboveIdx", this.hide_above_idx)
    this.$store.commit("user/setPlansArr", JSON.parse(this.plans))
    this.$store.commit("user/setPlanIntervalName", this.plan_interval_name)
    if(this.is_upgrade==0){
      this.$store.commit("user/unshiftPlansArr", {name: "free", display_name: "Free", amount: 0, widget_imp_limit: 0, pop_up_imp_limit: 0, overlay_imp_limit: 0})
    }
    this.$store.commit("user/setPlanName", this.current_plan_name)
    //console.log("no_button", this.no_button)
  },
}
</script>
<style lang="scss" scoped>
.callout{
  a{
    color:white;
    text-decoration:none;
  }
}
table{
  .heatmap{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #0080ff, #00b2b5);
    color: white;
    vertical-align: middle;
  }
  .popup{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #dc3545, #ff7838);
    color: white;
    vertical-align: middle;
  }
  .widget{
    background: url(/images/hero_bg_pattern.png), linear-gradient(rgb(255, 170, 0), #f1d04e);
    color: white;
    vertical-align: middle;
  }
  .conversion{
    background: url(/images/hero_bg_pattern.png), linear-gradient(rgb(255, 170, 0), #f1d04e);
    color: white;
    vertical-align: middle;
  }
  th.empty{
    border: none;
    background: #ffff;
    padding:0.5rem 0.75rem;
  }
  strong{
    font-size: 1.5em
  }
  /* 高PVプランの高級カラー */
  th.\31m_pv{
    background: linear-gradient(135deg, #c0c0c0, #e8e8e8);
    color: #333;
    font-weight: bold;
    text-shadow: 1px 1px 1px rgba(255,255,255,0.5);
  }
  th.\32m_pv{
    background: linear-gradient(135deg, #d4af37, #ffd700);
    color: #fff;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  }
}
</style>
